<ion-header>
  <ion-toolbar>
    <ion-title class="ion-no-padding"
      >{{ "domain.property.modal.inviteUsers.title" | transloco }}</ion-title
    >
    <ion-buttons slot="end">
      <ion-button (click)="onCancel()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-header collapse="condense">
    <ion-toolbar class="ion-no-padding">
      <ion-title size="large">
        {{ "domain.property.modal.inviteUsers.title" | transloco }}
      </ion-title>
    </ion-toolbar>
  </ion-header>
  <app-invite-users-to-stay></app-invite-users-to-stay>
</ion-content>
